import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { CheckBoxField } from '@unite-us/ui';
import { CommunicationTypeInfoIcon } from './components';
import { getCommunicationTypeInfo } from './utils';
import './stylesheets/communicationTypesCheckBoxes.scss';
import enums from '../../../../../constants/enums';
import { Field } from 'react-final-form';
function CommunicationTypesCheckBoxes(props) {
  var _context;
  var id = props.id,
    email = props.email,
    phone = props.phone,
    hideOralTypes = props.hideOralTypes,
    hideWrittenTypes = props.hideWrittenTypes,
    fieldName = props.fieldName,
    setCheckboxesRef = props.setCheckboxesRef;
  var contactDataEnums = get(enums, 'contact_data', {});
  var oralCommunicationTypes = hideOralTypes ? [] : get(contactDataEnums, 'oral_communication_types', []);
  var writtenCommunicationTypes = hideWrittenTypes ? [] : get(contactDataEnums, 'written_communication_types', []);
  var communicationTypes = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(oralCommunicationTypes), _toConsumableArray(writtenCommunicationTypes));
  var checkBoxes = _mapInstanceProperty(communicationTypes).call(communicationTypes, function () {
    var _context2, _context3;
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var index = arguments.length > 1 ? arguments[1] : undefined;
    return /*#__PURE__*/React.createElement("div", {
      className: "communication-types-checkboxes__checkbox-container",
      key: _concatInstanceProperty(_context2 = "$".concat(index, "-")).call(_context2, type.value)
    }, /*#__PURE__*/React.createElement(Field, {
      name: _concatInstanceProperty(_context3 = "".concat(fieldName, ".")).call(_context3, type.value),
      type: "checkbox"
    }, function (params) {
      var _context4, _context5, _context6;
      if (setCheckboxesRef) setCheckboxesRef(params);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckBoxField, _extends({
        className: "communication-types-checkboxes__checkbox",
        id: _concatInstanceProperty(_context4 = "".concat(fieldName, ".")).call(_context4, type.value),
        label: type.display_name,
        labelKey: "display_name",
        valueKey: "value"
      }, params)), /*#__PURE__*/React.createElement(CommunicationTypeInfoIcon, {
        className: "communication-types-checkboxes__info-icon",
        communicationType: type.value,
        id: _concatInstanceProperty(_context5 = _concatInstanceProperty(_context6 = "".concat(id, "-")).call(_context6, index, "-")).call(_context5, type.value, "-info-icon"),
        popoverContent: getCommunicationTypeInfo({
          communicationType: type.value,
          email: email,
          phone: phone
        })
      }));
    }));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "communication-types-checkboxes"
  }, checkBoxes);
}
CommunicationTypesCheckBoxes.propTypes = {
  id: PropTypes.string.isRequired,
  email: PropTypes.bool,
  phone: PropTypes.bool
};
CommunicationTypesCheckBoxes.defaultProps = {
  email: false,
  phone: false
};
export default CommunicationTypesCheckBoxes;
//# sourceMappingURL=index.js.map